import type { FC } from 'react';
import Input from '@components/Input';
import { Show, ShowFirstMatching } from '@components/Show';
import { VirtualizedList } from '@components/virtualization';
import { SearchIcon } from '@heroicons/react/outline';
import type { SubmissionShort } from '@queries/fetchSubmissions';

import { ContractListItem, ContractListLoadingSkeleton } from '../components';
import { LEFT_PANEL_HEIGHT_PX } from '../constants';

interface ContractsListProps {
  data: SubmissionShort[];
  isLoading: boolean;
  onAddContract: (contract: SubmissionShort) => void;
  onSearch: (value: string) => void;
  searchValue: string;
}

export const ContractsList: FC<ContractsListProps> = ({ data, isLoading, onAddContract, onSearch, searchValue }) => {
  return (
    <div className="flex min-w-0 flex-1 flex-col">
      <div className="relative mb-2">
        <SearchIcon className="text-info-400 pointer-events-none absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2" />
        <Input
          type="text"
          value={searchValue}
          disabled={isLoading}
          onChange={(event) => onSearch(event.currentTarget.value)}
          placeholder="Search contracts"
          className="border-info-300 focus:outline-primary-500 h-10 w-full rounded-md border py-2 pr-3 pl-9 text-sm leading-5 text-gray-700 shadow-xs"
        />
      </div>
      <div
        data-testid="contracts-list"
        className="border-info-200 mt-4 border-t shadow-[0_5px_2px_-2px_rgba(0,0,0,0.06)]"
      >
        <ShowFirstMatching>
          <Show when={isLoading}>
            <ContractListLoadingSkeleton />
          </Show>
          <Show when={!isLoading}>
            <VirtualizedList<SubmissionShort>
              className="divide-info-200 divide-y"
              data={data}
              itemHeight={54}
              height={LEFT_PANEL_HEIGHT_PX}
              renderItem={(contract) => <ContractListItem contract={contract} onAdd={onAddContract} />}
            />
          </Show>
        </ShowFirstMatching>
      </div>
    </div>
  );
};
